var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidenav',{class:_vm.curClasses,attrs:{"orientation":_vm.orientation}},[_c('div',{staticClass:"sidenav-inner",class:{ 'py-1': _vm.orientation !== 'horizontal' }},[_c('book-navigator')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }